import React, { useContext, useRef, useState } from "react";
import { axiosUrl } from "../../api/axios";
import { UserContext } from "../../App";
import DashboardLayout from "../../layouts/DashboardLayout";

const Wallet = () => {
  const { userData } = useContext(UserContext);

  const [editBtcAddress, setEditBtcAddress] = useState(true);
  const [btcAddress, setBtcAddress] = useState("");

  const [editDogeAddress, setEditDogeAddress] = useState(true);
  const [dogeAddress, setDogeAddress] = useState("");

  const [editEthAddress, setEditEthAddress] = useState(true);
  const [ethAddress, setEthAddress] = useState("");

  const [editUsdtAddress, setEditUsdtAddress] = useState(true);
  const [usdtAddress, setUsdtAddress] = useState("");

  const user = userData.user;

  // useEffect(() => {
  //   setAddress(user.btcAddress);
  //   console.log(address);
  // }, [user.btcAddress, address]);

  const AddressInput = useRef(null);

  const handleChangeBtc = (e) => {
    e.preventDefault();
    setBtcAddress(e.target.value);
  };
  const handleChangeDoge = (e) => {
    e.preventDefault();
    setDogeAddress(e.target.value);
  };
  const handleChangeEth = (e) => {
    e.preventDefault();
    setEthAddress(e.target.value);
  };
  const handleChangeUsdt = (e) => {
    e.preventDefault();
    setUsdtAddress(e.target.value);
  };

  const putAddressBtc = (e) => {
    e.preventDefault();

    const newAddress = {
      btcAddress: btcAddress,
    };

    axiosUrl.put("/users/profile", newAddress, {
      headers: {
        "auth-token": userData.token,
      },
    });

    alert("Bitcoin Wallet Address saved Successfully!!!");
    window.location = "/dashboard/wallet";
  };
  const putAddressDoge = (e) => {
    e.preventDefault();

    const newAddress = {
      dogeAddress: dogeAddress,
    };

    axiosUrl.put("/users/profile", newAddress, {
      headers: {
        "auth-token": userData.token,
      },
    });

    alert("Dogecoin Wallet Address saved Successfully!!!");
    window.location.href = "/dashboard/wallet";
  };
  const putAddressEth = (e) => {
    e.preventDefault();

    const newAddress = {
      ethAddress: ethAddress,
    };

    axiosUrl.put("/users/profile", newAddress, {
      headers: {
        "auth-token": userData.token,
      },
    });

    alert("Ethereum Wallet Address saved Successfully!!!");
    window.location = "/dashboard/wallet";
  };
  const putAddressUsdt = (e) => {
    e.preventDefault();

    const newAddress = {
      usdtAddress: usdtAddress,
    };

    axiosUrl.put("/users/profile", newAddress, {
      headers: {
        "auth-token": userData.token,
      },
    });

    alert("USDT Wallet Address saved Successfully!!!");
    window.location = "/dashboard/wallet";
  };

  return (
    <DashboardLayout>
      <div className="wallets">
        <h3 className="title-text sharp-text">Wallet</h3>

        <div className="top-nav">
          <a
            href="http://t.me/+bgUq1S1ZBZY1YTQ0"
            target="_blank"
            rel="noreferrer"
          >
            <button className="btn rounded">
              <i className="fas fa-paper-plane"></i>
              <p className="sharp-text">Contact Support</p>
            </button>
          </a>
        </div>

        <h6 className="title-text mt-5 mx-3">Your Wallets</h6>
        <div className="wallet-list">
          <div className="wallet btc">
            <div className="wallet-details">
              <div className="details">
                <p className="sharp-text crypto-type fw-bold">Bitcoin</p>
                <p className="sharp-text fw-bold balance">
                  {user.balance * 0.000026} <span>BTC</span>
                </p>
                {/* <p className="text-primary">
                  {user.balance}
                  <span> USD</span>
                </p> */}
              </div>
              <div className="show-address-btn">
                <img src="/imgs/bitcoin.png" alt="" />
              </div>
            </div>
            <div className="address">
              <form onSubmit={putAddressBtc}>
                <input
                  className={editBtcAddress ? "" : "edit-address"}
                  type="text"
                  value={editBtcAddress ? user.btcAddress : btcAddress}
                  disabled={editBtcAddress}
                  onChange={handleChangeBtc}
                  placeholder={
                    editBtcAddress
                      ? "Bitcoin Wallet address"
                      : "Paste your Address"
                  }
                  // onFocus={() => setAddress("")}
                />
                <div className="edit-btn">
                  <div className={editBtcAddress ? "d-none" : ""}>
                    <button
                      type="button"
                      className="btn-outline rounded mx-2"
                      onClick={() => {
                        setEditBtcAddress(true);
                        setBtcAddress("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn-outline rounded save-btn"
                    >
                      Save
                    </button>
                  </div>
                  <button
                    type="button"
                    className={`btn-outline rounded ${
                      editBtcAddress ? "" : "d-none"
                    }`}
                    onClick={() => {
                      setEditBtcAddress(false);
                    }}
                  >
                    Edit Address
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="wallet eth">
            <div className="wallet-details">
              <div className="details">
                <p className="sharp-text crypto-type fw-bold">Ethereum</p>
                <p className="sharp-text fw-bold balance">
                  {user.balance * 0.001726} <span>ETH</span>
                </p>
                {/* <p className="text-primary">
                  {user.balance}
                  <span> USD</span>
                </p> */}
              </div>
              <div className="show-address-btn">
                <img src="/imgs/eth.png" alt="" />
              </div>
            </div>
            <div className="address">
              <form onSubmit={putAddressEth}>
                <input
                  className={editEthAddress ? "" : "edit-address"}
                  type="text"
                  value={editEthAddress ? user.ethAddress : ethAddress}
                  disabled={editEthAddress}
                  ref={AddressInput}
                  onChange={handleChangeEth}
                  placeholder={
                    editEthAddress
                      ? "Ethereum Wallet Address"
                      : "Paste your Address"
                  }
                  // onFocus={() => setAddress("")}
                />
                <div className="edit-btn">
                  <div className={editEthAddress ? "d-none" : ""}>
                    <button
                      type="button"
                      className="btn-outline rounded mx-2"
                      onClick={() => {
                        setEditEthAddress(true);
                        setEthAddress("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn-outline rounded save-btn"
                    >
                      Save
                    </button>
                  </div>
                  <button
                    type="button"
                    className={`btn-outline rounded ${
                      editEthAddress ? "" : "d-none"
                    }`}
                    onClick={() => {
                      setEditEthAddress(false);
                    }}
                  >
                    Edit Address
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="wallet usdt">
            <div className="wallet-details">
              <div className="details">
                <p className="sharp-text crypto-type fw-bold">USDT</p>
                <p className="sharp-text fw-bold balance">
                  {user.balance * 1.0} <span>USDT</span>
                </p>
                {/* <p className="text-primary">
                  {user.balance}
                  <span> USD</span>
                </p> */}
              </div>
              <div className="show-address-btn">
                <img src="/imgs/USDT.png" alt="" />
              </div>
            </div>
            <div className="address">
              <form onSubmit={putAddressUsdt}>
                <input
                  className={editUsdtAddress ? "" : "edit-address"}
                  type="text"
                  value={editUsdtAddress ? user.usdtAddress : usdtAddress}
                  disabled={editUsdtAddress}
                  ref={AddressInput}
                  onChange={handleChangeUsdt}
                  placeholder={
                    editUsdtAddress
                      ? "USDT Wallet Address"
                      : "Paste your Address"
                  }
                  // onFocus={() => setAddress("")}
                />
                <div className="edit-btn">
                  <div className={editUsdtAddress ? "d-none" : ""}>
                    <button
                      type="button"
                      className="btn-outline rounded mx-2"
                      onClick={() => {
                        setEditUsdtAddress(true);
                        setUsdtAddress("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn-outline rounded save-btn"
                    >
                      Save
                    </button>
                  </div>
                  <button
                    type="button"
                    className={`btn-outline rounded ${
                      editUsdtAddress ? "" : "d-none"
                    }`}
                    onClick={() => {
                      setEditUsdtAddress(false);
                    }}
                  >
                    Edit Address
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="wallet doge">
            <div className="wallet-details">
              <div className="details">
                <p className="sharp-text crypto-type fw-bold">Dogecoin</p>
                <p className="sharp-text fw-bold balance">
                  {user.balance * 66.75} <span>DOGE</span>
                </p>
                {/* <p className="text-primary">
                  {user.balance}
                  <span> USD</span>
                </p> */}
              </div>
              <div className="show-address-btn">
                <img src="/imgs/dogecoin.png" alt="" />
              </div>
            </div>
            <div className="address">
              <form onSubmit={putAddressDoge}>
                <input
                  className={editDogeAddress ? "" : "edit-address"}
                  type="text"
                  value={editDogeAddress ? user.dogeAddress : dogeAddress}
                  disabled={editDogeAddress}
                  ref={AddressInput}
                  onChange={handleChangeDoge}
                  placeholder={
                    editDogeAddress
                      ? "Dogecoin Wallet Address"
                      : "Paste your Address"
                  }
                  // onFocus={() => setAddress("")}
                />
                <div className="edit-btn">
                  <div className={editDogeAddress ? "d-none" : ""}>
                    <button
                      type="button"
                      className="btn-outline rounded mx-2"
                      onClick={() => {
                        setEditDogeAddress(true);
                        setDogeAddress("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn-outline rounded save-btn"
                    >
                      Save
                    </button>
                  </div>
                  <button
                    type="button"
                    className={`btn-outline rounded ${
                      editDogeAddress ? "" : "d-none"
                    }`}
                    onClick={() => {
                      setEditDogeAddress(false);
                    }}
                  >
                    Edit Address
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Wallet;
